export const categoryKeys = {
  GROCERY_COUPONS: 4000,
  TRAVEL: 5001,
  ACTIVITIES: 5002,
  CARS: 5003,
  FLIGHTS: 5004,
  HOTELS: 5005, // for travel app tab selection
  THEMEPARKS: 5006,
  HOT_DEALS: 5007,
  EVENTS: 5008,
  CRUISE: 5009,
  EAT: 39, // Also named:  Dining & Food
  PLAY: 59, // Also named: Entertainment & Recreation
  SHOP: 45, // Also named: Shopping
  HOTEL: 44, // hotels category ID from API/DB
  CAR_RENTAL: 58, // car_rental category ID from API/DB
  MOVIES: 56,
  GOLF: 48,
  SKI_SNOWBOARD: 55,
  HEALTH_WELLNESS: 53,
  HOME_GARDEN: 1039,
  SERVICES: 50,
  AUTOMOTIVE: 51,
  CONDOS_RESORTS: 54,
  CRUISES_TOURS: 60,
  AMUSEMENT_PARKS: 1018,
  CLASSES: 1019,
  FUN_CENTER: 1013,
  CONCERTS_EVENTS: 1014,
  MUSEUMS_ZOOS_TOURS: 1015,
  OUTDOOR_ADVENTURE: 1016,
  SPORTING_EVENTS: 1017,
  APPAREL_ACCESSORIES: 1077,
  ART: 1078,
  CRAFTS: 1083,
  ELECTRONICS: 1086,
  FURNITURE: 1090,
  GIFTS: 1091,
  OFFICE_SUPPLIES: 1095,
  OTHER_SHOPPING: 1102,
  SPORTING_GOODS: 1099,
  BUSINESS_OFFICE: 1113,
  INSURANCE: 1065,
  FINANCIAL_WELLNESS: 1064,
  TRAVEL_BRAND_DEALS: 38,
};

export const categoryNavId = {
  LOCAL_DEALS: "localDeals",
  ONLINE_DEALS: "onlineDeals",
  HOTELS: "hotels",
  CAR_RENTALS: "carRentals",
  FLIGHTS: "flights",
  PARKS_AND_TICKETS: "parksAndTickets",
  ACTIVITIES: "activities",
  EVENTS: "events",
};

export const mainNavId = {
  HOTELS: "main-nav-hotels",
  PARKS_AND_TICKETS: "main-nav-parks-and-tickets",
  CARS: "main-nav-cars",
  FLIGHTS: "main-nav-flights",
  CRUISE: "main-nav-cruise",
  ACTIVITIES: "main-nav-activities",
  MOVIES: "main-nav-movies",
  MOVIE_TICKETS: "main-nav-movie-tickets",
  GOLF: "main-nav-golf",
  DINING_DEALS: "main-nav-dining-deals",
  SHOPPING_DEALS: "main-nav-shopping-deals",
  INSURANCE: "main-nav-insurance",
  FINANCIAL_WELLNESS: "main-nav-financial-wellness",
  HEALTH_WELLNESS: "main-nav-health-wellness",
  EVENTS: "main-nav-events",
  ENTERTAINMENT_RECREATION: "main-nav-entertainment-recreation",
  EAT: "main-nav-eat",
  PLAY: "main-nav-play",
  SHOP: "main-nav-shop",
  TRAVEL: "main-nav-travel",
  SERVICES: "main-nav-services",
  AUTOMOTIVE: "main-nav-automotive",
  BUSINESS_OFFICE: "main-nav-business-office",
  CAR_RENTAL: "main-nav-car-rental",
  CONDOS_RESORTS: "main-nav-condos-resorts",
  CRUISES_TOURS: "main-nav-cruises-tours",
  HOTEL: "main-nav-hotel",
  HOME_GARDEN: "main-nav-home-garden",
  SKI_SNOWBOARD: "main-nav-ski-snowboard",
  GROCERY_COUPONS: "main-nav-grocery-coupons",
  DISCOUNT_DEALS: "main-nav-discount-deals",
  PARKS: "main-nav-parks",
};

export const offerType = {
  ONLINE: "only",
  IN_STORE: "none",
  ALL_DEALS: "include",
};

export const offerSortBy = {
  RELEVANCE: "relevance",
  DISTANCE: "distance",
  POPULARITY: "uses",
};
